import { useEffect, useMemo, useState } from "react";
import AddNewDeal from "./add-deal";
import SaleTurnInSourcePicker from "./SaleTurnInSourcePicker";
import PendingInboxPanel from "./PendingInboxPanel";
import FollowUpsDueWidget from "../buyer-leads/FollowUpsDueWidget";
import BulkUploadDeals from "../deals/BulkUploadDeals";
import {
  getAlldealforAdmin,
  getTaskTemplate,
  getUserById,
  getuserinformation,
  saveitemwithid,
  getContactsByIds,
  updateIsShowStat,
  updateItem,
  updateBuyerLead,
  updateUserProfile,
  uploadImagesToFirebase,
} from "../../utils/firebasefunctions";
import { uploadPurchaseAgreementToStorage } from "../../utils/purchaseAgreementUpload";
import { useStateValue } from "../../context/StateProvider";
import { toast } from "react-toastify";
import { actionType } from "../../context/reducer";
import { arrayUnion, doc, onSnapshot, updateDoc } from "firebase/firestore";
import { firestored } from "../../firebase/firebaseConfig";
import { loadBrokerageSettings } from "../../utils/brokerageSettings";
import {
  formatCurrency,
  formatNumberShort,
  newmessagesuccess,
  notifyOnDealSubmit,
} from "../../utils/helper";
import TeamPerformanceDetail, {
  UpcomingClosingsPanel,
} from "../team-detail/performance-detail";
import StatDetails from "../deals/StatDetails";
import AllLeadStat from "../reuseable/all-lead-stat";
import StatDealsModal from "../reuseable/StatDealsModal";
import TeamPerformanceStats from "../team-detail/performance-stats";
import {
  Target,
  TrendingUp,
  TrendingDown,
  CheckCircle,
  AlertTriangle,
  ChevronDown,
  ChevronRight,
  Award,
  Zap,
  Calendar,
  DollarSign,
  BarChart3,
  Clock,
  Home,
  Hash,
  X,
  Plus,
  Users,
  Send,
  Handshake,
  FileText,
  ArrowUp,
  ArrowDown,
  Bell,
  FileTextIcon,
  ScrollText,
  RefreshCw,
  Upload,
} from "lucide-react";
import { Link, Navigate, useNavigate, useLocation } from "react-router-dom";
import PageHeader from "../PageHeader";
import { getToken } from "firebase/messaging";
import { messaging } from "../../firebase/firebaseConfig";

function HomeHero() {
  const [{ user, users, steps, deals }, dispatch] = useStateValue();
  const navigate = useNavigate();
  const location = useLocation();
  // Open the Sale Turn-In flow when sent here from a Buyer "Offer Accepted".
  useEffect(() => {
    if (location.state?.openTurnInSeed) {
      setTurnInSeed(location.state.openTurnInSeed);
      setIsOpen(true);
      navigate("/dashboard", { replace: true, state: null });
    } else if (location.state?.openTurnIn) {
      setTurnInPickerOpen(true);
      navigate("/dashboard", { replace: true, state: null });
    }
  }, [location.state, navigate]);
  const [isOpen, setIsOpen] = useState(false);
  const [turnInPickerOpen, setTurnInPickerOpen] = useState(false);
  const [turnInSeed, setTurnInSeed] = useState(null);
  // Clean dashboard: heavy reporting (monthly breakdown / team fees) is collapsed by default.
  // Sticky per-user: once you open "Show Details" it stays open across reloads
  // (keyed to your own account) until you collapse it again.
  const [showReports, setShowReports] = useState(false);
  useEffect(() => {
    if (!user?.id) return;
    try {
      if (localStorage.getItem(`dashShowReports:${user.id}`) === "1")
        setShowReports(true);
    } catch (e) {
      /* localStorage unavailable — keep the collapsed default */
    }
  }, [user?.id]);
  const toggleReports = () =>
    setShowReports((s) => {
      const next = !s;
      try {
        if (user?.id)
          localStorage.setItem(`dashShowReports:${user.id}`, next ? "1" : "0");
      } catch (e) {
        /* ignore persistence failures */
      }
      return next;
    });
  const [bulkform, setbulkform] = useState(false);
  const [isShowHomeStat] = useState(true); // CBR + Team Lead fee boxes always shown
  const [isShowStat, setIsShowStat] = useState(user?.isShowStats || false);
  const [isLoading, setIsLoading] = useState(false);
  const [statspopup, setstatspopup] = useState(false);
  const [selectedstat, setselectedstat] = useState("");
  const [statsdata, setstatsdata] = useState([]);
  // Drill-down popup for a dashboard money tile: { title, deals, amountOf } | null
  const [statDrill, setStatDrill] = useState(null);
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const [tasks, setTasks] = useState({});
  const today = new Date();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const isCurrentYear = selectedYear === currentYear;
  // Brokerage cap — editable in the super-admin area, stored in settings/brokerage.
  // Falls back to 70000 until loaded (or if the read fails) so nothing breaks.
  const [annualCap, setAnnualCap] = useState(70000);
  useEffect(() => {
    let cancelled = false;
    loadBrokerageSettings().then((s) => {
      if (!cancelled && s?.annualCap) setAnnualCap(s.annualCap);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  const daysElapsed = isCurrentYear
    ? Math.floor((today - new Date(selectedYear, 0, 1)) / 86400000) + 1
    : 365;
  const totalDays = 365;
  const daysRemaining = isCurrentYear ? totalDays - daysElapsed : 0;
  const monthsElapsed = isCurrentYear ? currentMonth + 1 : 12;
  const monthsRemaining = isCurrentYear ? 12 - monthsElapsed : 0;
  const unitsGoal = 0;

  let teamLeadDeals = [];
  const adminUsers = users?.filter((user) => user.role === "Admin") || [];

  useEffect(() => {
    const client = window.google.accounts.oauth2.initTokenClient({
      client_id:
        "627842934381-7bra6ha78jub716ceu9hq433chsh69dn.apps.googleusercontent.com",
      scope: "https://www.googleapis.com/auth/contacts.readonly",
      callback: (response) => {
        if (response.access_token) {
          // fetchContacts(response.access_token);
        }
      },
    });

    window.loginWithGoogle = () => {
      client.requestAccessToken();
    };
  }, []);

  useEffect(() => {
    getalldeal();
    console.log(users);
  }, []);

  useEffect(() => {
    //  if (user?.id) {
    //   if (user?.id != undefined) {
    //     requestPermission();
    //   }
    // }

    const fetchUserData = async () => {
      if (!user?.id) return;

      const userData = await getUserById(user.id);
      console.log(userData);

      if (userData && userData.isShowStats !== undefined) {
        setIsShowStat(userData.isShowStats);
      }
    };

    fetchUserData();
  }, [user?.id]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getTaskTemplate();
      setTasks(data || {});
      console.log("task templates", data);
    };

    fetchData();
  }, []);

  ///////////////////////// general //////////////////////
  const closedDeals = deals?.filter(
    (deal) =>
      deal?.dealStage === "Closed" &&
      deal?.status === "Approved" &&
      new Date(deal?.closingdate).getFullYear() === currentYear,
  );

  const pendingDeals = deals?.filter(
    (deal) =>
      deal.dealStage.toLowerCase() != "closed" &&
      deal.dealStage.toLowerCase() != "cancelled" &&
      deal.dealStage.toLowerCase() != "expired" &&
      new Date(deal?.closingdate).getFullYear() === currentYear,
  );

  // Agent's own upcoming closings (their pending deals with a closing date),
  // for the standalone Upcoming Closings widget shown beside Follow-Ups Due.
  const myUpcomingDeals = (deals || [])
    .filter(
      (d) =>
        d?.dealStage?.toLowerCase() === "pending" &&
        d?.closingdate &&
        d?.agentData === user?.id,
    )
    .sort((a, b) => new Date(a.closingdate) - new Date(b.closingdate));
  const myUpcomingCommission = myUpcomingDeals.reduce(
    (s, d) => s + Number(d?.agentCommissionamount || 0),
    0,
  );
  ///////////////////////////////////////////////////////
  ///////////////////////// Team Lead //////////////////////

  const totalClosedCommission = closedDeals?.reduce(
    (sum, deal) => sum + Number(deal?.takehomecommissionamount || 0),
    0,
  );

  const calculateFeesByCapType = (deal, userId) => {
    const brokerAdminFee = Number(deal?.brokeradminfee) || 0;
    const capType = String(deal?.captype || "")
      .toLowerCase()
      .trim();

    let bankFee = 0;
    let teamLeadFee = 0;
    let teamLeadDeal = null;

    if (capType === "pre") {
      bankFee = brokerAdminFee;
    }

    if (capType === "post") {
      teamLeadFee = brokerAdminFee;
      teamLeadDeal = deal;
    }

    return { bankFee, teamLeadFee, teamLeadDeal };
  };

  const totalBankFees = closedDeals?.reduce((sum, deal) => {
    const { bankFee } = calculateFeesByCapType(deal, user.id);
    return sum + bankFee;
  }, 0);

  const totalTeamLeadFees = closedDeals?.reduce((sum, deal) => {
    const { teamLeadDeal, teamLeadFee } = calculateFeesByCapType(deal, user.id);

    if (!teamLeadDeal) return sum;

    return sum + teamLeadFee;
  }, 0);

  // const totalTeamLeadFees = closedDeals?.reduce((sum, deal) => {
  //   const { teamLeadFee, teamLeadDeal } = calculateFeesByCapType(deal, user.id);

  //   if (teamLeadDeal) {
  //     adminUsers.forEach((admin) => {
  //       const isMatch = deal.assignedteamlead === admin.id;

  //       if (isMatch) {
  //         if (!teamLeadDeals[admin.id]) {
  //           teamLeadDeals[admin.id] = {
  //             user: admin,
  //             deals: [],
  //             adminFee: 0, // 👈 new key
  //           };
  //         }

  //         teamLeadDeals[admin.id].deals.push(deal);

  //         // 👇 brokeradminfee ka sum
  //         teamLeadDeals[admin.id].adminFee += Number(deal.brokeradminfee) || 0;
  //       }
  //     });
  //   }

  //   return sum + teamLeadFee;
  // }, 0);

  const totalbrokarCommission = closedDeals?.reduce(
    (sum, deal) => sum + Number(deal?.bankcommission || 0),
    0,
  );

  const totalPendingbrokarCommission = pendingDeals?.reduce(
    (sum, deal) => sum + Number(deal?.bankcommission || 0),
    0,
  );

  const totaladminfee = closedDeals?.reduce(
    (sum, deal) => sum + Number(deal?.brokeradminfee || 0),
    0,
  );

  const totalpendingadminfee = pendingDeals?.reduce(
    (sum, deal) => sum + Number(deal?.brokeradminfee || 0),
    0,
  );

  const totalCommission = Math.max(
    annualCap -
      (totalbrokarCommission +
        totaladminfee +
        totalPendingbrokarCommission +
        totalpendingadminfee),
    0,
  );

  ///////////////////////////////////////////////////////
  ///////////////////////// Real State Agent //////////////////////

  const filteredDeals = deals.filter(
    (deal) =>
      deal.agentData === user.id &&
      !["closed", "expired", "cancelled"].includes(
        deal.dealStage?.toLowerCase(),
      ) &&
      deal?.status === "Approved" &&
      new Date(deal.closingdate).getFullYear() === selectedYear,
  );

  const agentPendingCommission = filteredDeals.reduce(
    (sum, deal) => sum + Number(deal.agentCommissionamount || 0),
    0,
  );

  const filterClosedDeals = deals?.filter(
    (deal) =>
      deal.agentData === user.id &&
      deal?.dealStage === "Closed" &&
      deal?.status === "Approved" &&
      new Date(deal?.closingdate).getFullYear() === selectedYear,
  );

  const closedDealsCount = filterClosedDeals.filter(
    (d) =>
      d.dealStage.toLowerCase() === "closed" &&
      new Date(d.closingdate).getFullYear() === selectedYear &&
      (user?.role === "Admin"
        ? d?.agentData == user.id ||
          (d?.splittype == "NoSplit" && d?.assignedteamlead == user.id) ||
          (d?.splittype === "Referral" && d?.agentData == "") ||
          (d?.splittype === "TeamSplit" && d?.inhousereferral == true)
        : d?.agentData == user.id && d?.inhousereferral != true),
  );

  const agentClosedCommission = filterClosedDeals.reduce(
    (sum, deal) => sum + Number(deal.agentCommissionamount || 0),
    0,
  );

  const agentClosedVolume = closedDealsCount.reduce(
    (sum, deal) => sum + Number(deal.offerPrice || 0),
    0,
  );

  // Split logic based on PaidToBroker + AdminFee
  const totalSpent = totalbrokarCommission + totaladminfee;
  // Cap-aware pending: only the part of open-deal (commission + admin) that still
  // fits UNDER the cap. Once capped (totalSpent >= annualCap) this is $0 — so the
  // dashboard never shows "pending" owed to the broker after you've capped.
  const remainingCapRoom = Math.max(0, annualCap - totalSpent);
  const pendingTowardCap = Math.min(
    totalPendingbrokarCommission + totalpendingadminfee,
    remainingCapRoom,
  );
  // Paid to broker is capped: once commission + admin reach the cap, the broker
  // takes no more, so this never exceeds the cap. Anything over the cap is admin
  // fees that flow to YOU (post-cap) — tracked in "My Admin Fees" below.
  const paidToBroker = Math.min(totalSpent, annualCap);
  const myAdminFees = Math.max(
    0,
    totaladminfee - Math.max(0, annualCap - totalbrokarCommission),
  );
  // Admin fees that actually went to the broker (pre-cap) = total admin minus
  // the post-cap portion that becomes yours.
  const adminToBroker = Math.max(0, totaladminfee - myAdminFees);
  const splitPercentage = totalSpent >= annualCap ? "100" : "90/10";

  // Progress bar calculation
  const progressPercent = Math.min((totalSpent / annualCap) * 100, 100).toFixed(
    2,
  );

  ///////////Closed Units GoalL///////////////////////////

  let currentYearClosedUnitsGoal = 0; // default

  if (user.closedyearlygoals) {
    const found = user.closedyearlygoals.find(
      (item) => item.year === selectedYear,
    );
    currentYearClosedUnitsGoal = found ? found.count : 0;
  }

  const agentclosedunitsProgressPercent = Math.min(
    (closedDealsCount.length / currentYearClosedUnitsGoal) * 100,
    100,
  ).toFixed(2);

  //////////////////////////////////////

  ///////////Closed Volume GoalL///////////////////////////

  let currentYearClosedVolumeGoal = 0; // default

  if (user.closedvolumeyearlygoals) {
    const found = user.closedvolumeyearlygoals.find(
      (item) => item.year === selectedYear,
    );
    currentYearClosedVolumeGoal = found ? found.amount : 0;
  }

  const agentVolumeProgressPercent = Math.min(
    (agentClosedVolume / currentYearClosedVolumeGoal) * 100,
    100,
  ).toFixed(2);

  //////////////////////////////////////

  ///////////GCI GOAL///////////////////////////

  let currentYearGoal = 0; // default

  if (user.yearlyGoals) {
    const found = user.yearlyGoals.find((item) => item.year === selectedYear);
    currentYearGoal = found ? found.amount : 0;
  }

  const agentProgressPercent = Math.min(
    (agentClosedCommission / currentYearGoal) * 100,
    100,
  ).toFixed(2);

  const columnIds = [
    "Prospect",
    "On Hold",
    "CMAs",
    "Listing Appointment",
    "Pre-Market",
    "Coming Soon",
    "Active",
    "Under Contract",
    "Pending",
    "Closed",
    "Cancelled",
    "Expired",
  ];

  //////////////////////////////////////

  const submitdeal = async (data, bool, existingId) => {
    // existingId set → this is a Sale Turn-In of a listing ALREADY on the board:
    // MOVE that card to Under Contract in place (merge) instead of creating a
    // duplicate deal. Empty for new deals / "Start From Scratch".
    const isMove = !!existingId;
    let id = isMove ? existingId : Date.now();
    setIsLoading(true);
    try {
      // Run all three async pre-steps in parallel — photo upload, PA upload,
      // and contact lookup don't depend on each other, so the total wait is
      // max(t1, t2, t3) instead of sum(t1, t2, t3). Saves several seconds on
      // submits that include photos AND a PA.
      const photoP =
        data.step1.propertyphotofiles?.length > 0
          ? uploadImagesToFirebase(data.step1.propertyphotofiles)
          : Promise.resolve([]);

      const paP = data.attachedPaFile
        ? uploadPurchaseAgreementToStorage(user.id, data.attachedPaFile)
        : Promise.resolve(null);

      const firstClientId = (data.step2.clientinfo || []).find(
        (c) => c && c !== "",
      );
      const lastNameP = firstClientId
        ? getContactsByIds([firstClientId])
            .then((arr) => (arr?.[0]?.lastname || "").trim())
            .catch((err) => {
              console.error("Couldn't resolve client lastname:", err);
              return "";
            })
        : Promise.resolve("");

      let imageUrls, pendingPurchaseAgreement, clientLastName;
      try {
        [imageUrls, pendingPurchaseAgreement, clientLastName] =
          await Promise.all([photoP, paP, lastNameP]);
      } catch (paErr) {
        // Storage uploads (photo or PA) failed. Surface the error and bail.
        toast.error(`Couldn't upload: ${paErr.message}`);
        setIsLoading(false);
        return;
      }

      const selectedStage = data.step1.dealStage;

      const stageIndex = columnIds.indexOf(selectedStage);
      const allowedStages = columnIds.slice(0, stageIndex + 1);

      let allTasks = [];
      let taskStatusTracker = {};

      allowedStages.forEach((stage) => {
        const stageTasks = Array.isArray(tasks?.[stage]) ? tasks[stage] : [];

        // 🔥 tasks add karo
        allTasks = [...allTasks, ...stageTasks];

        // 🔥 tracker banao
        taskStatusTracker[stage] = true;
      });

      let newdata = {
        status: bool ? "Approved" : "Pending",
        requestType: "saleTurnIn",
        propertyphoto: imageUrls,
        // Read by onDealCreate trigger (functions-drive); cleared
        // automatically once the PA has been uploaded to Drive.
        pendingPurchaseAgreement,
        // Used by folderName.js on the trigger to build the Drive
        // folder name "<address> — <lastname>".
        clientLastName,
        dealtype: data.step2.clientType,
        customers: data.step2.clientinfo,
        // priority: data.step1.Priority,
        dealStage: data.step1.dealStage,
        financingType: data.step1.financingType,
        // listingPrice: data.step1.listingPrice,
        earnestMoney: data.step1.earnestMoney,
        // mlsNumber: data.step1.mlsNumber,
        offerPrice: data.step1.offerPrice,
        propertyType: data.step1.propertyType,
        agentCommission: data.step3.agentCommission,
        fixedagentcommission: data.step3.fixedagentcommission,
        agentData: data.step3.agentid,
        agentName: data.step3.agentName,
        brokeradminfee: data.step3.brokeradminfee,
        captype: data.step3.captype,
        captypedescription: data.step3.captypedescription,
        closingdate: data.step1.closingdate,
        inspection: data.step1.inspection,
        propertyLocation: data.step1.propertyLocation,
        inspectionDeadline: data.step1.inspectionDeadline,
        financingDeadline: data.step1.financingDeadline,
        leadCommission: data.step3.leadCommission,
        leadsource: data.step3.leadsource,
        propertyaddress: data.step1.propertyaddress,
        splitdescription: data.step3.splitdescription,
        splittype: data.step3.splittype,
        inhousereferral: data.step3?.inhousereferral || false,
        teamleadName: data.step3.teamleadName,
        flatfee: data.step4.flatfee,
        flatfeeamount: data.step4.flatfeeamount,
        assignedteamlead: data.step3.assignedteamlead,
        thirdpartyagentCommission: data.step3.thirdpartyagentCommission,
        thirdpartyagentName: data.step3.thirdpartyagentName,
        agentCommissionamount: data.step4.agentCommissionamount,
        bankcommission: data.step4.bankcommission,
        buyersidecommissionrate: data.step4.buyersidecommissionrate,
        leadsourceCommissionamount: data.step4.leadsourceCommissionamount,
        sellersidecommissionrate: data.step4.sellersidecommissionrate,
        takehomecommissionamount: data.step4.takehomecommissionamount,
        teamleadCommissionamount: data.step4.teamleadCommissionamount,
        teamleaddiscount: data.step4.teamleaddiscount,
        agentdiscount: data.step4.agentdiscount,

        teamleadcommissionrate: data.step4.teamleadcommissionrate,
        thirdpartyagentcommissionamount:
          data.step4.thirdpartyagentcommissionamount,
        totalCommissionamount: data.step4.totalCommissionamount,
        totalcommissionrate: data.step4.totalcommissionrate,
        tasks: allTasks,
        taskStatusTracker: taskStatusTracker,

        createdby: user.id,
        createdat: isMove ? Number(existingId) || existingId : id,
      };

      // Moving an existing listing: preserve its identity and progress — don't
      // overwrite the original creator or its task state (merge keeps the rest
      // of the listing's data, e.g. lockbox / contacts / listing details).
      if (isMove) {
        delete newdata.createdby;
        delete newdata.tasks;
        delete newdata.taskStatusTracker;
        // No new photo picked → keep the listing's existing photo (otherwise the
        // merge would overwrite it with []).
        if (!imageUrls || imageUrls.length === 0) delete newdata.propertyphoto;
      }

      console.log(newdata);

      // Firestore rejects `undefined` field values — replace them with null
      // so a property that wasn't geocoded (or any other unset field) doesn't
      // blow up the entire submit. Without this, a single missing field
      // throws "setDoc() called with invalid data" and the agent can't
      // turn in the deal.
      for (const k of Object.keys(newdata)) {
        if (newdata[k] === undefined) newdata[k] = null;
      }

      let result = await saveitemwithid("deals", id.toString(), newdata);

      if (result == "success") {
        // Close the modal IMMEDIATELY. Everything below runs in the
        // background so the agent isn't watching a spinner.
        toast.success(
          isMove
            ? "Listing moved to Under Contract."
            : "Deal created successfully!",
        );
        // Turn-in came from a BUYER pipeline lead → archive it as a won,
        // fully-converted buyer. Status "converted" removes it from the active
        // pipeline (main-buyer-leads hides converted); outcome "won" + the deal
        // link track it as a fully-converted buyer. Fire-and-forget.
        if (
          !isMove &&
          turnInSeed?.sourceLeadType === "buyer" &&
          turnInSeed?.sourceLeadId
        ) {
          updateBuyerLead(turnInSeed.sourceLeadId, {
            status: "converted",
            outcome: "won",
            convertedDealId: String(id),
            convertedAt: Date.now(),
          }).catch((e) =>
            console.error("Couldn't archive the converted buyer lead:", e),
          );
        }

        setIsOpen(false);
        setTurnInSeed(null);
        setIsLoading(false);

        // Fire-and-forget task notifications. Skipped on a move — we kept the
        // listing's existing tasks rather than adding new ones.
        if (!isMove)
          allTasks.forEach((task) => {
            if (task?.assignee) {
              newmessagesuccess(
                "New Task Assigned",
                task.assignee?.id,
                task?.title || "",
                task.id || "",
                "newtask",
                newdata.createdat,
              );
            }
          });

        // Watch for the PA-upload trigger to finish (or fail). 60s timeout.
        if (pendingPurchaseAgreement) {
          toast.info("Uploading purchase agreement to Drive…");
          const dealRef = doc(firestored, "deals", id.toString());
          let unsub;
          const stop = setTimeout(() => unsub && unsub(), 60_000);
          unsub = onSnapshot(dealRef, (snap) => {
            const d = snap.data() || {};
            if (!d.pendingPurchaseAgreement) {
              toast.success("Purchase agreement saved to Drive.");
              clearTimeout(stop);
              unsub && unsub();
            } else if (
              typeof d.driveFolderError === "string" &&
              d.driveFolderError.startsWith("Purchase agreement upload failed")
            ) {
              toast.error(d.driveFolderError);
              clearTimeout(stop);
              unsub && unsub();
            }
          });
        }

        // Notify approvers in the background. Failures just log; they don't
        // affect the user's view since the modal is already closed.
        notifyOnDealSubmit({ ...newdata, createdat: id }, users, user).catch(
          (notifyErr) => {
            console.error("Failed to notify on deal submit:", notifyErr);
          },
        );
      } else {
        toast.error(result || "Failed to create deal");
        setIsLoading(false);
      }
    } catch (err) {
      toast.error(err.message);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getDataFromChild = (data) => {
    setSelectedYear(data);
  };

  async function getalldeal() {
    await getAlldealforAdmin("deals")
      .then(async (response) => {
        dispatch({
          type: actionType.STORE_DEALS,
          deals: response,
        });
      })
      .catch((err) => {
        alert(err);
      });
  }
  const toggleState = async () => {
    const newValue = !isShowStat;
    setIsShowStat(newValue);

    const success = await updateIsShowStat(user.id, newValue);
  };
  // Format value display based on toggle
  const formatValue = (value, isFormat = true) => {
    if (!isShowStat) return "****";
    if (isFormat) {
      return formatNumberShort(Number(value)); // short format apply here
    } else {
      return value;
    }
  };

  // const fetchContacts = async (token) => {
  //   try {
  //     const res = await fetch(
  //       "https://us-central1-team-edelstein.cloudfunctions.net/api/getcontacts",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           token: token,
  //         }),
  //       },
  //     );

  //     if (res.status === 200) {
  //       console.log("Successfully Retreived Contacts");
  //       const dataresponse = await res.json();
  //       console.log("All Contacts Backend " + JSON.stringify(dataresponse));
  //       let dataset = {
  //         contacts: dataresponse.data,
  //       };
  //       // await updateUserProfile(user.id, dataset);
  //       // const userInfo = await getuserinformation("users", user.id);
  //       // dispatch({ type: actionType.SET_USER, payload: userInfo });
  //       localStorage.setItem("sync-ontact", JSON.stringify(dataset));
  //       toast.success("Contacts Synced Successfully!");
  //     } else {
  //       toast.error("Syncing Failed");
  //       console.log("Authentication Error");
  //     }
  //   } catch (error) {
  //     toast.error("Authentication Error");
  //     console.error("Error:", error);
  //   }
  // };

  //   async function requestPermission() {
  //   //requesting permission using Notification API
  //   const permission = await Notification.requestPermission();

  //   if (permission === "granted") {
  //     const token = await getToken(messaging, {
  //       vapidKey:
  //         "BKNonFk-lAUXh-_LSJ6F1aoG1ZfVupq3qc3FsR2WgQw48IpnqLWRQ5MrYDqFzG4xNfAxovO6AB51e5lhp1JDG3Y",
  //     });

  //     //We can send token to server
  //     console.log("Token generated : ", token);
  //     if (
  //       user?.NotificationToken == undefined ||
  //       user?.NotificationToken?.find((data) => data == token) == undefined
  //     ) {
  //       updatenotificationtoken(token);
  //     }
  //   } else if (permission === "denied") {
  //     //notifications are blocked
  //     alert("You denied for the notification");
  //   }
  // }

  //  const updatenotificationtoken = async (token) => {
  //   let data = {
  //     NotificationToken: arrayUnion(token),
  //   };
  //   await updateItem("users", user?.id, data)
  //     .then(async (response) => {})
  //     .catch((err) => {
  //       alert(err);
  //     });
  // };

  const DashboardStat = () => {
    return (
      <section className="relative bg-gradient-to-b from-[#0f172a] to-[#1E293B] text-white rounded-2xl px-6 py-5 lg:px-8 lg:py-6 shadow-xl overflow-hidden animate-[slideIn_0.6s_ease]">
        {/* Slim header row — title on the left, Current Split + Show Stats on the
           right. Stays a compact bar when stats are hidden; the heavy cards only
           render (below) when Show Stats is on. */}
        <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3">
          <div>
            <h3 className="text-lg lg:text-xl font-bold leading-tight">
              {user?.role === "Admin" || user.role === "Accountant"
                ? `🎯 ${selectedYear} ${user.firstname} ${user.lastname} Goal Tracking`
                : `${selectedYear} Performance Goals`}
            </h3>
            <p className="text-white/50 text-xs mt-0.5">
              {isCurrentYear
                ? `${daysRemaining} days remaining · ${today.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}`
                : "Year completed"}
            </p>
          </div>
          <div className="flex items-center gap-4">
            {isShowStat && user.role != "Employee" && (
              <div className="text-center bg-white/10 px-4 py-1.5 rounded-xl backdrop-blur-md">
                <div className="text-[10px] uppercase tracking-wide opacity-70">
                  Current Split
                </div>
                <div
                  id="currentSplitDisplay"
                  className="text-xl font-bold leading-tight"
                >
                  {formatValue(splitPercentage, false)}
                </div>
              </div>
            )}
            <div className="flex items-center gap-2">
              <label className="text-white/80 text-sm font-medium">
                Show Stats:
              </label>
              <button
                onClick={toggleState}
                className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors duration-300 focus:outline-none ${
                  isShowStat ? "bg-themeColor" : "bg-gray-300"
                }`}
              >
                <span
                  className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                    isShowStat ? "translate-x-6" : "translate-x-1"
                  }`}
                ></span>
              </button>
            </div>
          </div>
        </div>

        {isShowStat && (
          <>
            <section className="relative mt-6">
              {user.role == "Admin" || user.role === "Accountant" ? (
                <div>
                  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 mb-5 relative">
                    {/*  Paid To Broker */}
                    <div
                      class="text-left bg-white/[0.08] p-5 rounded-2xl backdrop-blur-md hover:bg-white/[0.12] transform hover:-translate-y-1 transition cursor-pointer"
                      onClick={() =>
                        setStatDrill({
                          title: "Paid To Broker",
                          deals: closedDeals || [],
                          amountOf: (d) => Number(d?.bankcommission || 0),
                        })
                      }
                    >
                      <div className="flex justify-between items-start mb-3">
                        <div className="w-10 h-10 rounded-xl bg-indigo-500/20 flex items-center justify-center">
                          <Hash size={20} className="text-indigo-300" />
                        </div>
                      </div>
                      <div
                        className="text-xl xl:text-2xl 2xl:text-3xl font-extrabold tracking-tight mb-0.5"
                        title={formatCurrency(totalbrokarCommission)}
                      >
                        ${formatValue(totalbrokarCommission)}
                      </div>
                      <div className="text-xs text-white/50 mb-3">
                        Paid To Broker
                      </div>
                    </div>

                    {/* Remaining */}
                    <div
                      class="text-left bg-white/[0.08] p-5 rounded-2xl backdrop-blur-md hover:bg-white/[0.12] transform hover:-translate-y-1 transition cursor-pointer"
                      onClick={() => {
                        // openDrawer(`Volume – ${selectedYear}`, closedDeals);
                      }}
                    >
                      <div className="flex justify-between items-start mb-3">
                        <div className="w-10 h-10 rounded-xl bg-emerald-500/20 flex items-center justify-center">
                          <BarChart3 size={20} className="text-emerald-300" />
                        </div>
                      </div>
                      <div
                        className="text-xl xl:text-2xl 2xl:text-3xl font-extrabold tracking-tight mb-0.5"
                        title={formatCurrency(totalCommission)}
                      >
                        ${formatValue(totalCommission)}
                      </div>
                      <div className="text-xs text-white/50 mb-3">
                        Remaining
                      </div>
                    </div>

                    {/* Pending */}
                    <div
                      class="text-left bg-white/[0.08] p-5 rounded-2xl backdrop-blur-md hover:bg-white/[0.12] transform hover:-translate-y-1 transition cursor-pointer"
                      onClick={() =>
                        setStatDrill({
                          title: "Pending",
                          deals: pendingDeals || [],
                          amountOf: (d) =>
                            Number(d?.bankcommission || 0) +
                            Number(d?.brokeradminfee || 0),
                        })
                      }
                    >
                      <div className="flex justify-between items-start mb-3">
                        <div className="w-10 h-10 rounded-xl bg-blue-500/20 flex items-center justify-center">
                          <Home size={20} className="text-blue-300" />
                        </div>
                      </div>
                      <div
                        className="text-xl xl:text-2xl 2xl:text-3xl font-extrabold tracking-tight mb-0.5"
                        title={formatCurrency(pendingTowardCap)}
                      >
                        ${formatValue(pendingTowardCap)}
                      </div>
                      <div className="text-xs text-white/50 mb-3">Pending</div>
                    </div>

                    {/* Paid */}
                    <div
                      class="text-left bg-white/[0.08] p-5 rounded-2xl backdrop-blur-md hover:bg-white/[0.12] transform hover:-translate-y-1 transition cursor-pointer"
                      onClick={() =>
                        setStatDrill({
                          title: "Paid",
                          deals: closedDeals || [],
                          amountOf: (d) =>
                            Number(d?.bankcommission || 0) +
                            Number(d?.brokeradminfee || 0),
                        })
                      }
                    >
                      <div className="flex justify-between items-start mb-3">
                        <div className="w-10 h-10 rounded-xl bg-amber-500/20 flex items-center justify-center">
                          <DollarSign size={20} className="text-amber-300" />
                        </div>
                      </div>
                      <div
                        className="text-xl xl:text-2xl 2xl:text-3xl font-extrabold tracking-tight mb-0.5"
                        title={formatCurrency(paidToBroker)}
                      >
                        ${formatValue(paidToBroker)}
                      </div>
                      <div className="text-xs text-white/50 mb-3">Paid</div>
                    </div>

                    {/* Admin FEE YTD */}
                    <div
                      class="text-left  p-5 rounded-2xl bg-white/[0.08] backdrop-blur-md hover:bg-white/[0.12] transform hover:-translate-y-1 transition cursor-pointer"
                      onClick={() =>
                        setStatDrill({
                          title: "Admin Fees (Pre-Cap)",
                          deals: closedDeals || [],
                          amountOf: (d) => Number(d?.brokeradminfee || 0),
                        })
                      }
                    >
                      <div className="flex justify-between items-start mb-3">
                        <div className="w-10 h-10 rounded-xl bg-amber-500/20 flex items-center justify-center">
                          <DollarSign size={20} className="text-amber-300" />
                        </div>
                      </div>
                      <div
                        className="text-xl xl:text-2xl 2xl:text-3xl font-extrabold tracking-tight mb-0.5"
                        title={formatCurrency(adminToBroker)}
                      >
                        ${formatValue(adminToBroker)}
                      </div>
                      <div className="text-xs text-white/50 mb-3">
                        Admin Fees (Pre-Cap)
                      </div>
                    </div>
                  </div>
                  {isShowHomeStat && (
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-5">
                      <div
                        class="text-center bg-white/[0.08] p-5 rounded-2xl backdrop-blur-md hover:bg-white/[0.12] transform hover:-translate-y-1 transition cursor-pointer"
                        onClick={() =>
                          setStatDrill({
                            title: "What We Paid CBR",
                            deals: (closedDeals || []).filter(
                              (d) =>
                                calculateFeesByCapType(d, user.id).bankFee > 0,
                            ),
                            amountOf: (d) =>
                              calculateFeesByCapType(d, user.id).bankFee,
                          })
                        }
                      >
                        <div
                          title={formatCurrency(totalBankFees)}
                          class="text-lg xl:text-xl 2xl:text-2xl font-bold tracking-tight mb-1"
                        >
                          ${formatValue(totalBankFees)}
                        </div>
                        <div class="opacity-90 text-xs">What We Paid CBR</div>
                      </div>
                      <div
                        class="text-center bg-white/[0.08] p-5 rounded-2xl backdrop-blur-md hover:bg-white/[0.12] transform hover:-translate-y-1 transition cursor-pointer"
                        onClick={() =>
                          setStatDrill({
                            title: "Total Pending Admin Fees",
                            deals: (pendingDeals || []).filter(
                              (d) => Number(d?.brokeradminfee || 0) > 0,
                            ),
                            amountOf: (d) => Number(d?.brokeradminfee || 0),
                          })
                        }
                      >
                        <div
                          title={formatCurrency(totalpendingadminfee)}
                          class="text-lg xl:text-xl 2xl:text-2xl font-bold tracking-tight mb-1"
                        >
                          ${formatValue(totalpendingadminfee)}
                        </div>
                        <div class="opacity-90 text-xs">
                          Total Pending Admin Fees
                        </div>
                      </div>
                      <div
                        class="text-center bg-white/[0.08] p-5 rounded-2xl backdrop-blur-md hover:bg-white/[0.12] transform hover:-translate-y-1 transition ring-1 ring-emerald-400/30 cursor-pointer"
                        onClick={() => {
                          // Fill the cap's admin-fee room (what's left after
                          // commission) deal by deal in closing order; whatever
                          // spills past the cap is the post-cap share per deal.
                          let room = Math.max(
                            0,
                            annualCap - totalbrokarCommission,
                          );
                          const ordered = [...(closedDeals || [])].sort(
                            (a, b) =>
                              new Date(a?.closingdate || 0) -
                              new Date(b?.closingdate || 0),
                          );
                          const mine = new Map();
                          ordered.forEach((d) => {
                            const fee = Number(d?.brokeradminfee || 0);
                            const toBroker = Math.min(fee, room);
                            room -= toBroker;
                            if (fee - toBroker > 0)
                              mine.set(d?.createdat || d?.id, fee - toBroker);
                          });
                          setStatDrill({
                            title: "Total Admin Fees Post Cap",
                            deals: ordered.filter((d) =>
                              mine.has(d?.createdat || d?.id),
                            ),
                            amountOf: (d) =>
                              mine.get(d?.createdat || d?.id) || 0,
                          });
                        }}
                      >
                        <div
                          title={formatCurrency(myAdminFees)}
                          class="text-lg xl:text-xl 2xl:text-2xl font-bold tracking-tight mb-1 text-emerald-300"
                        >
                          ${formatValue(myAdminFees)}
                        </div>
                        <div class="opacity-90 text-xs">
                          Total Admin Fees Post Cap
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="relative">
                    <div className="flex justify-between mb-2 text-sm">
                      <span>Progress to Cap</span>
                      <span id="capProgressPercent">
                        {formatValue(progressPercent)}% Complete
                      </span>
                    </div>

                    <div className="h-6 rounded-full bg-white/20 overflow-hidden relative">
                      {/* 🍀 Progress Fill Layer */}
                      <div
                        id="capProgressBar"
                        className="h-full transition-all duration-500 bg-amber-600"
                        style={{
                          width: isShowStat ? `${progressPercent}%` : "0%",
                        }}
                      ></div>

                      {/* 🍀 Text Layer (Always Centered) */}
                      <div className="absolute inset-0 flex items-center justify-center text-white font-semibold text-sm pointer-events-none">
                        ${formatValue(paidToBroker)} / ${formatValue(annualCap)}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                  {/* UNITS */}
                  <div
                    className="bg-white/[0.08] rounded-2xl p-5 border border-white/[0.06] hover:bg-white/[0.12] transition cursor-pointer"
                    onClick={() => {
                      // openDrawer(`Units Closed – ${selectedYear}`, closedDeals)
                    }}
                  >
                    <div className="flex justify-between items-start mb-3">
                      <div className="w-10 h-10 rounded-xl bg-indigo-500/20 flex items-center justify-center">
                        <Hash size={20} className="text-indigo-300" />
                      </div>

                      {/* {unitsGoal > 0 && (
                <span
                  className={`text-[10px] font-semibold px-2 py-1 rounded-full ${unitsClosed >= Math.round((unitsGoal / totalDays) * daysElapsed) ? "bg-emerald-500/20 text-emerald-300" : "bg-red-500/20 text-red-300"}`}
                >
                  {unitsClosed >=
                  Math.round((unitsGoal / totalDays) * daysElapsed)
                    ? `+${unitsClosed - Math.round((unitsGoal / totalDays) * daysElapsed)} ahead`
                    : `${unitsClosed - Math.round((unitsGoal / totalDays) * daysElapsed)} behind`}
                </span>
              )} */}
                    </div>
                    <div className="text-xl xl:text-2xl 2xl:text-3xl font-extrabold tracking-tight mb-0.5">
                      {closedDealsCount.length}
                    </div>
                    <div className="text-xs text-white/50 mb-3">
                      Units Closed
                    </div>
                    {currentYearClosedUnitsGoal > 0 && (
                      <>
                        <div className="flex justify-between text-[10px] text-white/40 mb-1.5">
                          <span>Goal: {currentYearClosedUnitsGoal}</span>
                          <span className="text-indigo-300">
                            {agentclosedunitsProgressPercent}%
                          </span>
                        </div>
                        <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
                          <div
                            className="h-full rounded-full bg-gradient-to-r from-indigo-400 to-purple-400 transition-all duration-700"
                            style={{
                              width: `${agentclosedunitsProgressPercent}%`,
                            }}
                          />
                        </div>
                      </>
                    )}
                    {/* <div className="flex justify-between mt-2.5 text-[11px]">
              <span className="text-white/40">
                Pending:{" "}
                <strong className="text-white/70">{unitsPending}</strong>
              </span>
              <span className="text-white/40">
                Pace: <strong className="text-white/70">{unitsPace}/mo</strong>
              </span>
            </div> */}
                    {/* {lyUnits > 0 && (
              <div className="mt-2 pt-2 border-t border-white/[0.06]">
                <YoyBadge diff={yoyUnits} format={(v) => `${v} units`} />
              </div>
            )} */}
                  </div>

                  {/* VOLUME */}
                  <div
                    className="bg-white/[0.08] rounded-2xl p-5 border border-white/[0.06] hover:bg-white/[0.12] transition cursor-pointer"
                    onClick={() => {
                      // openDrawer(`Volume – ${selectedYear}`, closedDeals);
                    }}
                  >
                    <div className="flex justify-between items-start mb-3">
                      <div className="w-10 h-10 rounded-xl bg-emerald-500/20 flex items-center justify-center">
                        <BarChart3 size={20} className="text-emerald-300" />
                      </div>
                      {/* {volumeGoal > 0 && (
                <span className="text-[10px] font-semibold px-2 py-1 rounded-full bg-emerald-500/20 text-emerald-300">
                  {volumeProgress.toFixed(1)}%
                </span>
              )} */}
                    </div>
                    <div className="text-xl xl:text-2xl 2xl:text-3xl font-extrabold tracking-tight mb-0.5">
                      ${formatNumberShort(agentClosedVolume)}
                    </div>
                    <div className="text-xs text-white/50 mb-3">Volume</div>
                    {currentYearClosedVolumeGoal > 0 && (
                      <>
                        <div className="flex justify-between text-[10px] text-white/40 mb-1.5">
                          <span>
                            Goal: $
                            {formatNumberShort(currentYearClosedVolumeGoal)}
                          </span>
                          <span className="text-emerald-300">
                            {agentVolumeProgressPercent}%
                          </span>
                        </div>
                        <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
                          <div
                            className="h-full rounded-full bg-gradient-to-r from-emerald-400 to-green-400 transition-all duration-700"
                            style={{
                              width: `${agentVolumeProgressPercent}%`,
                            }}
                          />
                        </div>
                      </>
                    )}
                    {/* <div className="flex justify-between mt-2.5 text-[11px]">
              <span className="text-white/40">
                Projected:{" "}
                <strong className="text-white/70">
                  ${formatNumberShort(volumeProjected)}
                </strong>
              </span>
            </div> */}
                    {/* {lyVolume > 0 && (
              <div className="mt-2 pt-2 border-t border-white/[0.06]">
                <YoyBadge
                  diff={yoyVolume}
                  format={(v) => `$${formatNumberShort(v)}`}
                />
              </div>
            )} */}
                  </div>

                  {/* AVG SALE PRICE */}
                  <div className="bg-white/[0.08] rounded-2xl p-5 border border-white/[0.06] hover:bg-white/[0.12] transition">
                    <div className="flex justify-between items-start mb-3">
                      <div className="w-10 h-10 rounded-xl bg-blue-500/20 flex items-center justify-center">
                        <Home size={20} className="text-blue-300" />
                      </div>
                    </div>
                    <div className="text-xl xl:text-2xl 2xl:text-3xl font-extrabold tracking-tight mb-0.5">
                      $
                      {formatNumberShort(
                        agentClosedVolume / closedDealsCount.length,
                      )}
                    </div>
                    <div className="text-xs text-white/50 mb-3">
                      Avg Sale Price
                    </div>
                    {/* <div className="h-1.5 rounded-full bg-white/10 overflow-hidden mb-2.5">
              <div
                className="h-full rounded-full bg-gradient-to-r from-blue-400 to-cyan-400"
                style={{ width: "100%" }}
              />
            </div> */}
                    {/* <div className="flex justify-between text-[11px]">
              <span className="text-white/40">
                High:{" "}
                <strong className="text-white/70">
                  ${formatNumberShort(highestPrice)}
                </strong>
              </span>
              <span className="text-white/40">
                Low:{" "}
                <strong className="text-white/70">
                  ${formatNumberShort(lowestPrice)}
                </strong>
              </span>
            </div> */}
                    {/* {lyAvg > 0 && (
              <div className="mt-2 pt-2 border-t border-white/[0.06]">
                <YoyBadge
                  diff={yoyAvg}
                  format={(v) => `$${formatNumberShort(v)}`}
                />
              </div>
            )} */}
                  </div>

                  {/* GCI */}
                  <div
                    className="bg-white/[0.08] rounded-2xl p-5 border border-white/[0.06] hover:bg-white/[0.12] transition cursor-pointer"
                    onClick={() => {
                      // openDrawer(`GCI – ${selectedYear}`, closedDeals);
                    }}
                  >
                    <div className="flex justify-between items-start mb-3">
                      <div className="w-10 h-10 rounded-xl bg-amber-500/20 flex items-center justify-center">
                        <DollarSign size={20} className="text-amber-300" />
                      </div>
                      {/* {gciGoal > 0 && (
                <span
                  className={`text-[10px] font-semibold px-2 py-1 rounded-full ${gciVariance >= 0 ? "bg-emerald-500/20 text-emerald-300" : "bg-red-500/20 text-red-300"}`}
                >
                  {gciVariance >= 0
                    ? `+$${formatNumberShort(gciVariance)} ahead`
                    : `-$${formatNumberShort(Math.abs(gciVariance))} behind`}
                </span>
              )} */}
                    </div>
                    <div className="text-xl xl:text-2xl 2xl:text-3xl font-extrabold tracking-tight mb-0.5">
                      ${formatNumberShort(agentClosedCommission)}
                    </div>
                    <div className="text-xs text-white/50 mb-3">GCI Earned</div>
                    {currentYearGoal > 0 && (
                      <>
                        <div className="flex justify-between text-[10px] text-white/40 mb-1.5">
                          <span>
                            Goal: ${formatNumberShort(currentYearGoal)}
                          </span>
                          <span className="text-amber-300">
                            {agentProgressPercent}%
                          </span>
                        </div>
                        <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
                          <div
                            className="h-full rounded-full bg-gradient-to-r from-amber-400 to-yellow-400 transition-all duration-700"
                            style={{ width: `${agentProgressPercent}%` }}
                          />
                        </div>
                      </>
                    )}
                    {/* <div className="flex justify-between mt-2.5 text-[11px]">
              <span className="text-white/40">
                Pending:{" "}
                <strong className="text-white/70">
                  ${formatNumberShort(gciPending)}
                </strong>
              </span>
              <span className="text-white/40">
                Pace:{" "}
                <strong className="text-white/70">
                  ${formatNumberShort(gciExpected)}
                </strong>
              </span>
            </div> */}
                    {/* {lyGci > 0 && (
              <div className="mt-2 pt-2 border-t border-white/[0.06]">
                <YoyBadge
                  diff={yoyGci}
                  format={(v) => `$${formatNumberShort(v)}`}
                />
              </div>
            )} */}
                  </div>
                </div>
              )}
            </section>
          </>
        )}
      </section>
    );
  };

  const headerActions = user.role !== "Accountant" && (
    <div className="flex items-center gap-2">
      <button
        onClick={() => navigate("/dashboard/listing-request?type=seller")}
        title="Listing Request"
        className="inline-flex items-center gap-2 px-3.5 py-2 text-sm font-semibold rounded-md border border-slate-200 bg-white text-slate-800 hover:border-slate-300 hover:shadow-sm transition"
      >
        <span className="w-6 h-6 rounded bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center">
          <ScrollText size={13} className="text-white" />
        </span>
        <span className="hidden lg:inline">Listing Request</span>
      </button>
      <button
        onClick={() => navigate("/dashboard/listing-request?type=buyer")}
        title="Buyer Request"
        className="inline-flex items-center gap-2 px-3.5 py-2 text-sm font-semibold rounded-md border border-slate-200 bg-white text-slate-800 hover:border-slate-300 hover:shadow-sm transition"
      >
        <span className="w-6 h-6 rounded bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center">
          <Handshake size={13} className="text-white" />
        </span>
        <span className="hidden lg:inline">Buyer Request</span>
      </button>
      <button
        onClick={() => setTurnInPickerOpen(true)}
        title="Sale Turn In"
        className="inline-flex items-center gap-2 px-3.5 py-2 text-sm font-semibold rounded-md border border-slate-200 bg-white text-slate-800 hover:border-slate-300 hover:shadow-sm transition"
      >
        <span className="w-6 h-6 rounded bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center">
          <Send size={13} className="text-white" />
        </span>
        <span className="hidden lg:inline">Sale Turn In</span>
      </button>
    </div>
  );

  return (
    <main class="">
      <PageHeader title="Dashboard" actions={headerActions} />

      {/* Action tile grid wrapper — only render when there's actually a tile
          to show. Employee/Accountant have 0 tiles here (primary actions live
          in the PageHeader now), so we skip the empty wrapper + its padding. */}
      {(user.role === "Admin" || user.role === "Supervisor") && (
      <div className="px-3 lg:px-6 pt-3 lg:pt-6 ">
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
          {user.role !== "Accountant" && (
            <>
              {/* Bulk Upload lives in Settings > Bulk Upload Deals now. */}

              {user.role === "Supervisor" && (
                <button
                  onClick={() => window.loginWithGoogle?.()}
                  className="group flex items-center gap-3 bg-white rounded-xl border border-gray-200 px-4 py-3 text-left transition-all hover:-translate-y-0.5 hover:shadow-md hover:border-gray-300"
                >
                  <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center flex-shrink-0 shadow-sm group-hover:scale-105 transition-transform">
                    <RefreshCw size={16} className="text-white" />
                  </div>
                  <span className="font-semibold text-sm text-gray-800">
                    Sync Contacts
                  </span>
                </button>
              )}
            </>
          )}
          {/* 
          <button
            onClick={() => {
              // navigate("/dashboard/deals")
            }}
            className="group flex items-center gap-3 bg-white rounded-xl border border-gray-200 px-4 py-3 text-left transition-all hover:-translate-y-0.5 hover:shadow-md hover:border-gray-300"
          >
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center flex-shrink-0 shadow-sm group-hover:scale-105 transition-transform">
              <Home size={16} className="text-white" />
            </div>
            <span className="font-semibold text-sm text-gray-800">
              Listing File Request
            </span>
          </button>
          <button
            onClick={() => {
              // navigate("/dashboard/deals")
            }}
            className="group flex items-center gap-3 bg-white rounded-xl border border-gray-200 px-4 py-3 text-left transition-all hover:-translate-y-0.5 hover:shadow-md hover:border-gray-300"
          >
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center flex-shrink-0 shadow-sm group-hover:scale-105 transition-transform">
              <Users size={16} className="text-white" />
            </div>
            <span className="font-semibold text-sm text-gray-800">
              Buyer File Request
            </span>
          </button> */}
          {/* <button
            // onClick={() => {
            //   setIsOpen(true);
            // }}
            className="group flex items-center gap-3 bg-white rounded-xl border border-gray-200 px-4 py-3 text-left transition-all hover:-translate-y-0.5 hover:shadow-md hover:border-gray-300"
          >
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center flex-shrink-0 shadow-sm group-hover:scale-105 transition-transform">
              <Plus size={16} className="text-white" />
            </div>
            <span className="font-semibold text-sm text-gray-800">
              New Deal
            </span>
          </button> */}
        </div>
      </div>
      )}

      <div className="">
        <div
          class={`page-content ${
            user.role === "Employee" ? "px-3 lg:px-6 pb-6" : "p-3 lg:p-6"
          }`}
        >
          {/* {user?.role === "Admin" && (
            <section class="relative bg-gradient-to-b from-[#0f172a] to-[#1E293B] text-white rounded-3xl p-10 lg:px-10 lg:py-8 mb-8 shadow-xl overflow-hidden animate-[slideIn_0.6s_ease]">
              <div className="flex justify-end items-center gap-2 ">
                <label className="text-white font-medium">Show Stats:</label>
                <button
                  onClick={toggleState}
                  className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors duration-300 focus:outline-none ${
                    isShowStat ? "bg-themeColor" : "bg-gray-300"
                  }`}
                >

                  <span
                    className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                      isShowStat ? "translate-x-6" : "translate-x-1"
                    }`}
                  ></span>
                </button>
              </div>

              {isShowStat && (
                <>
                  <div class="flex flex-col md:flex-row justify-between items-center mb-10 mt-5 gap-6">
                    <div>
                      <h3 class="text-2xl font-bold mb-2 text-center lg:text-left">
                        🎯 {user.firstname} {user.lastname} Broker Cap Progress
                      </h3>
                      <p class="opacity-95 text-sm md:text-base text-center lg:text-left">
                        Track your journey to 100% commission split
                      </p>
                    </div>

                    <div class="text-center lg:text-right bg-white/10 p-5 rounded-2xl backdrop-blur-md w-full lg:w-fit">
                      <div class="text-sm opacity-90 mb-1">Current Split</div>
                      <div id="currentSplitDisplay" class="text-3xl font-bold">
                        {formatValue(splitPercentage, false)}
                      </div>
                    </div>
                  </div>

                  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 mb-10 relative">
                    <div class="text-center bg-white/10 p-5 rounded-2xl backdrop-blur-md hover:bg-white/20 transform hover:-translate-y-1 transition">
                      <div
                        id="brokerPaidAmount"
                        class="text-3xl font-bold mb-2"
                      >
                        ${formatValue(totalbrokarCommission)}
                      </div>
                      <div class="opacity-95 text-sm">Paid to Broker</div>
                    </div>

                    <div class="text-center bg-white/10 p-5 rounded-2xl backdrop-blur-md hover:bg-white/20 transform hover:-translate-y-1 transition">
                      <div id="capRemaining" class="text-3xl font-bold mb-2">
                        ${formatValue(totalCommission)}
                      </div>
                      <div class="opacity-95 text-sm">Remaining</div>
                    </div>
                    <div class="text-center bg-white/10 p-5 rounded-2xl backdrop-blur-md hover:bg-white/20 transform hover:-translate-y-1 transition">
                      <div id="capRemaining" class="text-3xl font-bold mb-2">
                        $
                        {formatValue(
                          totalPendingbrokarCommission + totalpendingadminfee,
                        )}
                      </div>
                      <div class="opacity-95 text-sm">Pending</div>
                    </div>
                    <div class="text-center bg-white/10 p-5 rounded-2xl backdrop-blur-md hover:bg-white/20 transform hover:-translate-y-1 transition">
                      <div id="capRemaining" class="text-3xl font-bold mb-2">
                        ${formatValue(totalbrokarCommission + totaladminfee)}
                      </div>
                      <div class="opacity-95 text-sm">Paid</div>
                    </div>

                    <div
                      class="text-center bg-white/10 p-5 rounded-2xl backdrop-blur-md hover:bg-white/20 transform hover:-translate-y-1 transition cursor-pointer"
                      onClick={() => setIsShowHomeStat((prev) => !prev)}
                    >
                      <div id="adminFeesCount" class="text-3xl font-bold mb-2">
                        ${formatValue(totaladminfee)}
                      </div>
                      <div class="opacity-95 text-sm">Admin Fees YTD</div>
                    </div>
                  </div>
                  {isShowHomeStat && (
                    <div className="flex justify-between">
                      <div class="text-center bg-white/10 p-5 rounded-2xl backdrop-blur-md hover:bg-white/20 transform hover:-translate-y-1 transition w-[49%]">
                        <div
                          id="adminFeesCount"
                          class="text-3xl font-bold mb-2"
                        >
                          ${formatValue(totalBankFees)}
                        </div>
                        <div class="opacity-95 text-sm">CBR Fees YTD</div>
                      </div>

                      <div class="text-center bg-white/10 p-5 rounded-2xl backdrop-blur-md hover:bg-white/20 transform hover:-translate-y-1 transition w-[49%]">
                        <div
                          id="adminFeesCount"
                          class="text-3xl font-bold mb-2"
                        >
                          ${formatValue(totalTeamLeadFees)}
                        </div>
                        <div class="opacity-95 text-sm">Team Lead Fees YTD</div>
                      </div>
                    </div>
                  )}

                  <div className="relative">
                    <div className="flex justify-between mb-2 text-sm">
                      <span>Progress to Cap</span>
                      <span id="capProgressPercent">
                        {formatValue(progressPercent)}% Complete
                      </span>
                    </div>

                    <div className="h-10 rounded-full bg-white/20 overflow-hidden relative">

                      <div
                        id="capProgressBar"
                        className="h-full transition-all duration-500 bg-indigo-500"
                        style={{
                          width: isShowStat ? `${progressPercent}%` : "0%",
                        }}
                      ></div>


                      <div className="absolute inset-0 flex items-center justify-center text-white font-semibold text-sm pointer-events-none">
                        ${formatValue(paidToBroker)} / ${formatValue(annualCap)}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </section>
          )} */}
          {user?.role === "Employeee" && (
            <section class="relative bg-gradient-to-b from-[#0f172a] to-[#1E293B] text-white rounded-3xl p-10 lg:px-10 lg:py-8 mb-8 shadow-xl overflow-hidden animate-[slideIn_0.6s_ease]">
              <div className="flex justify-end items-center gap-2 ">
                <label className="text-white font-medium">Show Stats:</label>
                <button
                  onClick={toggleState}
                  className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors duration-300 focus:outline-none ${
                    isShowStat ? "bg-themeColor" : "bg-gray-300"
                  }`}
                >
                  {/* Circle */}
                  <span
                    className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                      isShowStat ? "translate-x-6" : "translate-x-1"
                    }`}
                  ></span>
                </button>
              </div>
              {/* <div class="absolute -top-1/2 right-[-10%] w-2/5 h-[200%] bg-[radial-gradient(circle,rgba(255,255,255,0.1)_0%,transparent_70%)] animate-[float_8s_ease-in-out_infinite]"></div> */}
              {isShowStat && (
                <>
                  <div class="flex flex-col md:flex-row justify-between items-center mb-10 mt-5 gap-6">
                    <div>
                      <h3 class="text-2xl font-bold mb-2 text-center lg:text-left">
                        🎯 {user.firstname} {user.lastname} Goal Tracking
                      </h3>
                      <p class="opacity-95 text-sm md:text-base text-center lg:text-left">
                        Track your journey
                      </p>
                    </div>
                  </div>

                  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10 relative">
                    <div class="text-center bg-white/10 p-5 rounded-2xl backdrop-blur-md hover:bg-white/20 transform hover:-translate-y-1 transition">
                      <div
                        id="brokerPaidAmount"
                        class="text-3xl font-bold mb-2"
                      >
                        ${formatValue(currentYearGoal)}
                      </div>
                      <div class="opacity-95 text-sm">Agent Goal</div>
                    </div>
                    <div class="text-center bg-white/10 p-5 rounded-2xl backdrop-blur-md hover:bg-white/20 transform hover:-translate-y-1 transition">
                      <div id="capRemaining" class="text-3xl font-bold mb-2">
                        ${formatValue(agentPendingCommission)}
                      </div>
                      <div class="opacity-95 text-sm">Pending</div>
                    </div>
                    <div class="text-center bg-white/10 p-5 rounded-2xl backdrop-blur-md hover:bg-white/20 transform hover:-translate-y-1 transition">
                      <div id="capRemaining" class="text-3xl font-bold mb-2">
                        ${formatValue(agentClosedCommission)}
                      </div>
                      <div class="opacity-95 text-sm">Closed Comission</div>
                    </div>

                    <div class="text-center bg-white/10 p-5 rounded-2xl backdrop-blur-md hover:bg-white/20 transform hover:-translate-y-1 transition cursor-pointer">
                      <div id="adminFeesCount" class="text-3xl font-bold mb-2">
                        ${formatValue(currentYearGoal - agentClosedCommission)}
                      </div>
                      <div class="opacity-95 text-sm">Remaining Commission</div>
                    </div>
                  </div>

                  <div className="relative">
                    <div className="flex justify-between mb-2 text-sm">
                      <span>Progress to Cap</span>
                      <span id="capProgressPercent">
                        {formatValue(agentProgressPercent)}% Complete
                      </span>
                    </div>

                    <div className="h-10 rounded-full bg-white/20 overflow-hidden relative">
                      {/* 🍀 Progress Fill Layer */}
                      <div
                        id="capProgressBar"
                        className="h-full transition-all duration-500 bg-indigo-500"
                        style={{
                          width: isShowStat ? `${agentProgressPercent}%` : "0%",
                        }}
                      ></div>

                      {/* 🍀 Text Layer (Always Centered) */}
                      <div className="absolute inset-0 flex items-center justify-center text-white font-semibold text-sm pointer-events-none">
                        ${formatValue(agentClosedCommission)} / $
                        {formatValue(currentYearGoal)}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </section>
          )}
          {/* Agents (Employees): performance card on top, with their
             Follow-Ups + Upcoming Closings row injected right under the name
             (equal-height boxes). */}
          {user.role === "Employee" && (
            <div className="mb-6">
              <TeamPerformanceDetail
                id={user.id}
                isWidth={false}
                childSelectedYear={getDataFromChild}
                dashboardview={false}
                hideHeader={true}
                isShowMonthly={true}
                hideUpcoming={true}
                topSlot={
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-5 items-stretch [&>*]:h-full [&>*]:!mb-0">
                    <FollowUpsDueWidget />
                    <UpcomingClosingsPanel
                      title="Upcoming Closings"
                      deals={myUpcomingDeals}
                      totalCommission={myUpcomingCommission}
                      today={today}
                      commissionForDeal={(d) =>
                        Number(d?.agentCommissionamount || 0)
                      }
                    />
                  </div>
                }
              />
            </div>
          )}

          {/* Action items (Admin/Supervisor) — Approvals + Follow-Ups. */}
          {user.role !== "Employee" && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6 items-stretch">
              {(user.role === "Admin" || user.role === "Supervisor") && (
                <PendingInboxPanel
                  deals={deals}
                  users={users}
                  currentUser={user}
                  onOpen={(deal) =>
                    navigate(`/dashboard/deals?approve=${deal.createdat}`)
                  }
                />
              )}
              <FollowUpsDueWidget />
            </div>
          )}

          {/* Full broker commission / cap "Goal Tracking" panel — restored.
             A prior dashboard redo swapped this for a compact card and left the
             rich panel (DashboardStat) defined but never rendered. Reconnecting
             it here brings back Paid To Broker / Pending / Paid / Admin Fee YTD /
             Current Split / Progress to Cap, behind the Show Stats privacy toggle. */}
          {user.role !== "Employee" && (
            <div className="mb-6">{DashboardStat()}</div>
          )}

          {/* Heavy reporting collapsed by default for Admin/Supervisor/Accountant
             to keep the dashboard calm. Employees keep it always-visible — it's
             their main dashboard content. */}
          {user.role !== "Employee" && (
            <button
              type="button"
              onClick={toggleReports}
              className="w-full mb-4 flex items-center gap-2 bg-white border border-dashed border-gray-300 rounded-2xl px-5 py-3.5 text-sm font-semibold text-slate-600 hover:border-gray-400 transition-colors"
            >
              <span className="text-slate-400">{showReports ? "▾" : "▸"}</span>
              {showReports ? "Hide Details" : "Show Details"}
              <span className="ml-auto text-xs font-medium text-slate-400">
                Monthly Breakdown · Team Lead Fees · Performance
              </span>
            </button>
          )}
          {user.role !== "Employee" && showReports && (
            <TeamPerformanceDetail
              id={user.id}
              isWidth={false}
              childSelectedYear={getDataFromChild}
              dashboardview={true}
              hideHeader={false}
              isShowMonthly={user.role === "Accountant" ? false : true}
            />
          )}
        </div>
      </div>

      {turnInPickerOpen && (
        <SaleTurnInSourcePicker
          onClose={() => setTurnInPickerOpen(false)}
          onSelect={(seed) => {
            setTurnInPickerOpen(false);
            setTurnInSeed(seed);
            setIsOpen(true);
          }}
        />
      )}

      {isOpen && (
        <AddNewDeal
          isLoading={isLoading}
          onClose={() => {
            setIsOpen(false);
            setTurnInSeed(null);
          }}
          onSubmit={(data, bool, existingId) => {
            submitdeal(data, bool, existingId);
          }}
          steps={steps}
          seed={turnInSeed}
        />
      )}

      {/* Bulk Upload moved to Settings > Bulk Upload Deals tab. */}

      {/* {statspopup && (
        <AllLeadStat
          onClose={() => setstatspopup(false)}
          data={teamLeadDeals}
        />
      )} */}

      {statDrill && (
        <StatDealsModal
          title={statDrill.title}
          deals={statDrill.deals}
          amountOf={statDrill.amountOf}
          onClose={() => setStatDrill(null)}
        />
      )}
    </main>
  );
}

export default HomeHero;
